export default __webpack_public_path__ + "static/media/Brig Gen Nazmul Ahsan.7eef7ecd.jpg";